'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _clipboard = require('clipboard');

var _clipboard2 = _interopRequireDefault(_clipboard);

var _CopyUrl = require('hudl-react-kickoff/icons/Copy-Url');

var _CopyUrl2 = _interopRequireDefault(_CopyUrl);

var _Facebook = require('hudl-react-kickoff/icons/Facebook');

var _Facebook2 = _interopRequireDefault(_Facebook);

var _Twitter = require('hudl-react-kickoff/icons/Twitter');

var _Twitter2 = _interopRequireDefault(_Twitter);

var _communityContentPlayers = require('../../../shared/logging/community-content-players');

var _communityContentPlayers2 = _interopRequireDefault(_communityContentPlayers);

var _pagescrollHelper = require('../../../utils/pagescroll-helper');

var _urls = require('../../../utils/urls');

var _urls2 = _interopRequireDefault(_urls);

var _feedUserType = require('../../../shared/feed-user-type');

var _feedUserType2 = _interopRequireDefault(_feedUserType);

var _Uniform = require('../../Uniform');

require('./_share-dialog.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _gaq = window._gaq || [];

var SharingDialog = function (_PureComponent) {
  _inherits(SharingDialog, _PureComponent);

  function SharingDialog() {
    _classCallCheck(this, SharingDialog);

    var _this = _possibleConstructorReturn(this, (SharingDialog.__proto__ || Object.getPrototypeOf(SharingDialog)).call(this));

    _this.onCopyUrl = function () {
      _this.setState({ urlCopied: true });
      setTimeout(function () {
        _this.setState({ urlCopied: false });
      }, 1000);

      _this.logShare('CopyLink');
    };

    _this.selectUrl = function () {
      _this.refs.url.select();
    };

    _this.shareFacebook = function () {
      var url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(_this.props.pageUrl);
      var windowName = 'facebook_share_dialog';
      var features = 'width=626,height=436';
      window.open(url, windowName, features);
      _gaq.push(['_trackSocial', 'facebook', 'share', _this.props.pageUrl]);

      _this.logShare('Facebook');
    };

    _this.shareTwitter = function () {
      var text = _this.props.twitterText;
      var hashtags = 'hudl';
      var pageUrl = encodeURIComponent(_this.props.pageUrl);
      var url = 'http://twitter.com/share?url=' + pageUrl + '&text=' + encodeURIComponent(text) + '&hashtags=' + hashtags;
      var windowName = 'twitterwindow';
      var features = 'height=450, width=550';
      window.open(url, windowName, features);
      _gaq.push(['_trackSocial', 'twitter', 'tweet', _this.props.pageUrl]);

      _this.logShare('Twitter', text, hashtags);
    };

    _this.state = {};
    return _this;
  }

  _createClass(SharingDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.clipboard = new _clipboard2.default('.sharing-item--copy', {
        text: function text() {
          return _this2.props.pageUrl;
        }
      });

      this.clipboard.on('success', this.onCopyUrl);

      this.clipboard.on('error', function () {
        _this2.setState({ copyError: true }, function () {
          _this2.selectUrl();
        });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clipboard.destroy();
    }
  }, {
    key: 'logShare',
    value: function logShare(network, text, hashtags) {
      var _props = this.props,
          communityContentId = _props.communityContentId,
          communityContentShared = _props.communityContentShared;


      var logData = _extends({
        pageUrl: this.props.pageUrl,
        network: network,
        player: this.props.logData.player || _communityContentPlayers2.default.Unknown
      }, this.props.logData);

      logData.AdditionalProperties = {};
      if (text) {
        logData.AdditionalProperties.Text = text;
      }
      if (hashtags) {
        logData.AdditionalProperties.HashTags = hashtags;
      }
      communityContentShared(communityContentId, logData);
    }
  }, {
    key: 'goToYourProfile',
    value: function goToYourProfile() {
      var communityContentId = this.props.communityContentId;


      window.location.href = _urls2.default.getFeedUserProfileUrl(_feedUserType2.default.User, communityContentId.secondaryRelatedId);
    }
  }, {
    key: 'goToHighlight',
    value: function goToHighlight() {
      window.location.href = this.props.pageUrl;
    }
  }, {
    key: 'renderNotification',
    value: function renderNotification() {
      if (!this.props.notification || !this.props.notification.body) {
        return null;
      }

      var className = classNames('share-buttons__notification', this.props.notification.className);

      return _react2.default.createElement(
        'div',
        { className: className },
        this.props.notification.body
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Uniform.Modal,
        {
          title: this.props.title,
          isOpen: true,
          onClose: this.props.onClose,
          onAfterOpen: _pagescrollHelper.disablePageScroll
        },
        _react2.default.createElement(
          'div',
          { className: 'feed-modal-content' },
          _react2.default.createElement(
            'div',
            { className: 'ko-field copy-field' + (this.state.copyError ? '' : ' hidden') },
            _react2.default.createElement('input', { type: 'text', readOnly: true, value: this.props.pageUrl, onClick: this.selectUrl, ref: 'url' })
          ),
          this.renderNotification(),
          _react2.default.createElement(
            'div',
            { className: 'sharing-content' },
            _react2.default.createElement(
              'div',
              { className: 'sharing-item', onClick: this.shareFacebook },
              _react2.default.createElement(
                'div',
                { className: 'icon facebook' },
                _react2.default.createElement(_Facebook2.default, null)
              ),
              _react2.default.createElement(
                _Uniform.Button,
                { type: 'subtle', style: 'minimal', size: 'medium' },
                'Share'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'sharing-item', onClick: this.shareTwitter },
              _react2.default.createElement(
                'div',
                { className: 'icon twitter', onClick: this.shareTwitter },
                _react2.default.createElement(_Twitter2.default, null)
              ),
              _react2.default.createElement(
                _Uniform.Button,
                { type: 'subtle', style: 'minimal', size: 'medium' },
                'Share'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'sharing-item sharing-item--copy' },
              _react2.default.createElement(
                'div',
                { className: 'icon copy' },
                _react2.default.createElement(_CopyUrl2.default, null)
              ),
              _react2.default.createElement(
                'div',
                { className: 'copy-button' },
                _react2.default.createElement(
                  _Uniform.Button,
                  { type: 'subtle', style: 'minimal', size: 'medium', status: this.state.urlCopied ? 'success' : '' },
                  this.state.urlCopied ? 'Copied' : 'Copy Link'
                )
              )
            )
          ),
          this.props.showHighlightCta ? _react2.default.createElement(
            'div',
            { className: 'highlight-sharing-cta' },
            _react2.default.createElement(
              'div',
              { className: 'divider' },
              _react2.default.createElement('span', { className: 'line' }),
              _react2.default.createElement(
                'span',
                { className: 'label' },
                'or'
              ),
              _react2.default.createElement('span', { className: 'line' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'cta-buttons' },
              _react2.default.createElement(_Uniform.Button, { type: 'subtle', text: 'Go To Your Profile',
                onClick: this.goToYourProfile.bind(this) }),
              _react2.default.createElement(_Uniform.Button, { type: 'subtle', text: 'Play Your Highlight',
                onClick: this.goToHighlight.bind(this) })
            )
          ) : null
        )
      );
    }
  }]);

  return SharingDialog;
}(_react.PureComponent);

SharingDialog.propTypes = {
  onClose: _react.PropTypes.func.isRequired,
  communityContentShared: _react.PropTypes.func.isRequired,
  title: _react.PropTypes.string.isRequired,
  twitterText: _react.PropTypes.string.isRequired,
  pageUrl: _react.PropTypes.string.isRequired,
  logData: _react.PropTypes.shape({
    OwnerId: _react.PropTypes.string,
    Type: _react.PropTypes.string,
    UserId: _react.PropTypes.string,
    Container: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
    ContainerSection: _react.PropTypes.string,
    ContainerType: _react.PropTypes.string
  }),
  communityContentId: _react.PropTypes.object,
  notification: _react.PropTypes.shape({
    body: _react.PropTypes.element,
    className: _react.PropTypes.string
  }),
  showHighlightCta: _react.PropTypes.bool
};
exports.default = SharingDialog;